import {
  Flex,
  Grid,
  Heading,
  Image,
  Skeleton,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useHistory } from "react-router-dom";
import { PartnerApp } from "views/admin/partnerDetail/types";

interface PartnerAppsViewProps {
  apps?: PartnerApp[];
  partnerId: number;
}

const PartnerAppsView = (props: PartnerAppsViewProps) => {
  const { apps, partnerId } = props;

  const history = useHistory();
  const bgHover = useColorModeValue(
    { bg: "brand.100" },
    { bg: "whiteAlpha.50" }
  );

  return (
    <Flex flexDir={"column"} mt={8}>
      <Flex p={4} borderRadius={"16"} mb={2} backgroundColor="white">
        <Heading fontSize={"xl"}>Games</Heading>
      </Flex>
      <Grid gap={4} templateColumns="repeat(3, 1fr)">
        {apps ? (
          apps.length > 0 ? (
            apps.map((app, index) => (
              <Flex
                backgroundColor={"white"}
                key={`${app.title} ${index}`}
                borderRadius={"16"}
                _hover={bgHover}
                p={4}
                alignItems="center"
                cursor="pointer"
                onClick={() => {
                  history.push("/partner/" + partnerId + "/app/" + app.appId);
                }}
              >
                <Image ml={0} src={app.iconUrl} boxSize={20} borderRadius={4} />
                <Flex flexDir={"column"} ml={8}>
                  <Text color={"black"} fontSize={"md"} fontWeight={"bold"}>
                    {app.title} ({app.platform})
                  </Text>
                  <Text mt={2} fontSize={"md"} fontWeight={"medium"}>
                    Campaigns: {app.campaignCount}
                  </Text>
                </Flex>
              </Flex>
            ))
          ) : (
            <Flex
              backgroundColor={"white"}
              borderRadius={"16"}
              p={4}
              alignItems="center"
              justify={"space-between"}
            >
              <Text color="gray.500">No app found for this partner.</Text>
            </Flex>
          )
        ) : (
          <>
            <Skeleton h={24} borderRadius={"16"} />
            <Skeleton h={24} borderRadius={"16"} />
            <Skeleton h={24} borderRadius={"16"} />
            <Skeleton h={24} borderRadius={"16"} />
          </>
        )}
      </Grid>
    </Flex>
  );
};

export default PartnerAppsView;
